/**
 * EFormQuestionTypeIcon — corp's icon for each e-form question type.
 */
import {
  AlignLeft,
  Calendar,
  CheckSquare,
  ChevronDown,
  CircleDot,
  Clock,
  CreditCard,
  EyeOff,
  FileUp,
  Globe,
  HelpCircle,
  ListOrdered,
  Mail,
  MapPin,
  MousePointerClick,
  PenTool,
  ScrollText,
  SeparatorHorizontal,
  StickyNote,
  Type,
  User,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<number, LucideIcon> = {
  10: Type,
  9: AlignLeft,
  18: User,
  14: Calendar,
  22: MapPin,
  20: MousePointerClick,
  7: CircleDot,
  8: CheckSquare,
  16: ChevronDown,
  12: FileUp,
  11: PenTool,
  19: StickyNote,
  23: StickyNote,
  28: ScrollText,
  13: SeparatorHorizontal,
  21: CreditCard,
  17: ListOrdered,
  27: Mail,
  15: EyeOff,
  24: Clock,
  26: Globe,
  25: StickyNote,
};

export function QuestionTypeIcon({ type, className }: { type: number; className?: string }) {
  const Icon = ICONS[type] ?? HelpCircle;
  return <Icon className={className} aria-hidden />;
}
